import React, { useEffect, useRef } from 'react';
import { FaStar, FaLeaf, FaMoneyBillWave, FaBolt } from 'react-icons/fa';

const Trust = () => {
  const ref = useRef(null);
  useEffect(() => {
    const io = new IntersectionObserver(
      (e) =>
        e.forEach((x) => x.isIntersecting && x.target.classList.add('show')),
      { threshold: 0.2 }
    );
    ref.current?.querySelectorAll('.reveal').forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  const reasons = [
    {
      icon: <FaLeaf />,
      title: 'Fresh & Hygienic',
      desc: 'Daily menu updates with top‑grade ingredients',
    },
    {
      icon: <FaMoneyBillWave />,
      title: 'Affordable Deals',
      desc: 'Combo pricing and frequent offers',
    },
    {
      icon: <FaBolt />,
      title: 'Temperature‑Safe',
      desc: 'Hot meals and crisp veggies on arrival',
    },
    {
      icon: <FaStar />,
      title: 'Trusted by Thousands',
      desc: 'Loved by urban professionals and families',
    },
  ];
  return (
    <section id="trust" className="section">
      <div className="container" ref={ref}>
        <div
          className="reveal"
          style={{ textAlign: 'center', marginBottom: 28 }}
        >
          <h2 className="title">Why Choose Mealzy?</h2>
          <p className="subtitle">
            All types of food and veggies in one app. Designed for busy
            lifestyles.
          </p>
        </div>

        <div className="grid grid-4" style={{ marginBottom: 28 }}>
          {reasons.map((r, i) => (
            <div key={i} className="reveal card" style={{ padding: 24 }}>
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 14,
                  background: 'var(--glass)',
                  border: '1px solid var(--glass-bd)',
                  display: 'grid',
                  placeItems: 'center',
                  fontSize: 22,
                  color: 'var(--primary-2)',
                }}
              >
                {r.icon}
              </div>
              <div style={{ fontWeight: 800, margin: '12px 0 6px' }}>
                {r.title}
              </div>
              <div style={{ color: 'var(--muted)' }}>{r.desc}</div>
            </div>
          ))}
        </div>

        <div
          className="reveal card"
          style={{
            padding: 24,
            display: 'grid',
            gridTemplateColumns: 'repeat(3,1fr)',
            gap: 18,
            textAlign: 'center',
          }}
        >
          {[
            { n: '10,000+', l: 'Happy Customers' },
            { n: '500+', l: 'Daily Orders' },
            { n: '4.8★', l: 'Average Rating' },
          ].map((s, i) => (
            <div key={i}>
              <div
                style={{
                  fontSize: 30,
                  fontWeight: 900,
                  background: 'var(--grad)',
                  WebkitBackgroundClip: 'text',
                  color: 'transparent',
                }}
              >
                {s.n}
              </div>
              <div style={{ color: 'var(--muted)', fontWeight: 700 }}>
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trust;
